/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
   name: "CRFversionControl",
    components: {
        VPagination,
    },
    data() {
    return {
        templatelistobj: {},
        baseapi: process.env.VUE_APP_Service_URL,
        baseurl: process.env.VUE_APP_Service_URL,

        formData: {
            form: "",
        },
        templateid: "",
        showTableLoading: false,
     showLoading: false,
     showLoadings: false,
        studyid: "",
            selectedUser: "",
        formTemplates: [],
        sourceTemplateId: "",
        roleprivileges: [],
        selectedTask: null,  
        sites: [],              
        selectedSites: [],
        site: { transitionRule: "Apply to All Subjects"},
        selectAll: false,
        versionhistoryarray: [],
        currentPage: 1,
        pageSize: 10,
        crfVersions: [],
        loading: false,
        idtoken: store.getters.getIdToken,
         allTemplates: [] ,
    };
},
    computed: {
        sortedTemplates() {
          const templates = this.templatelistobj[this.studyid] || [];
          const uniqueTemplates = {};
          
          templates
            .filter(t => t.status === "Approved")
            .forEach(t => {
              if (!uniqueTemplates[t.templateName]) {
                uniqueTemplates[t.templateName] = t;
              } else {
                const existingVersion = parseFloat(uniqueTemplates[t.templateName].version) || 0;
                const currentVersion = parseFloat(t.version) || 0;
                if (currentVersion > existingVersion) {
                  uniqueTemplates[t.templateName] = t;
                }
              }
            });
          
          return Object.values(uniqueTemplates)
            .sort((a, b) => a.templateName.localeCompare(b.templateName));
        },
  allSelectableSites() { 
    return this.paginatedSites.filter(site => !this.isSaveDisabled(site)); 
  },
  isSaveAllDisabled() {
    const selectableSites = this.paginatedSites.filter(site => !this.isSaveDisabled(site)); return selectableSites.length === 0 || this.selectedSites.length === 0;
  },
 paginatedSites() {

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    return this.sites.slice(start, end);

},
 availableVersions() {

    return this.versionhistoryarray.map(v => v.version);

},
    
    totalItems() {
        return Math.ceil(this.sites.length / this.pageSize);
    }
},

 watch: {
  'formData.form': {
    handler(newTemplateId) {

      if (!newTemplateId) return;
      const selectedTemplate =
        this.templatelistobj[this.studyid]?.find(
          t => t.templateId === newTemplateId
        );

      if (!selectedTemplate) return;

      const templateName = selectedTemplate.templateName;
      this.loadSitesForTemplate(templateName, this.studyid);
      this.updateTargetVersionForSites(selectedTemplate);

    },
    immediate: false
  },
  sortedTemplates: {
  immediate: true,
handler(newVal) {
  if (!newVal || newVal.length === 0) return;
  const stillValid = newVal.some(t => t.templateId === this.formData.form);
  if (!stillValid) {
    this.formData.form = newVal[0].templateId;
  }
}
},
  
 selectedSites(newVal) { this.selectAll = newVal.length === this.allSelectableSites.length; }
},



    async mounted() {
      this.studyid = store.getters.getStudyIs;
      this.roleprivileges = store.getters.getPrivileges || [];
      this.idtoken = store.getters.getIdToken;
      await this.loadCRFVersions(this.studyid);
      await this.listtemplate(this.studyid);
        if (this.templatelistobj[this.studyid]) {
    this.templatelistobj[this.studyid].sort((a, b) => 
      a.templateName.localeCompare(b.templateName)
    );
  }
      window.addEventListener("studyIdChanged", async () => {
        this.studyid = store.getters.getStudyIs;
        this.idtoken = store.getters.getIdToken;
        await this.loadCRFVersions(this.studyid);
        await this.listtemplate(this.studyid);
        if (this.templatelistobj[this.studyid]) {
      this.templatelistobj[this.studyid].sort((a, b) => 
        a.templateName.localeCompare(b.templateName)
      );
    }
      });
    },

    methods: {
        async loadCRFVersions(studyId) {
            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/template/listsitecrfversions?studyId=${studyId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const allVersions = response.data.results || [];
                const uniqueTemplates = {};
                allVersions.forEach(item => {
                    const key = item.templateName;
                    if (!uniqueTemplates[key]) {
                        uniqueTemplates[key] = {
                            templateId: item.id,
                            id: item.id,
                            templateName: item.templateName,
                            version: item.version,
                            ecrfSourceID: item.ecrfSourceID
                        };
                    }
                });

                this.templatelistobj[studyId] = Object.values(uniqueTemplates);
                this.formTemplates = Object.values(uniqueTemplates);
                if (this.formTemplates.length > 0) {
                    const firstTemplateName = this.formTemplates[0].templateName;
                 this.formData.form = this.formTemplates[0].templateId;
await this.loadSitesForTemplate(this.formTemplates[0].templateName, studyId);
                }

                console.log("CRF Templates loaded:", this.formTemplates);
            } catch (err) {
                console.error("Error loading CRF versions:", err);
            }
        },

      async listtemplate(studyid) {
        const idtoken = store.getters.getIdToken;

        try {
          const res = await axios.get(
            `${this.baseapi}/forms/template/listtemplate?StudyID=${studyid}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );

          const templates = (res.data.results || []).sort((a, b) => 
            a.templateName.localeCompare(b.templateName)
          );

          this.templatelistobj[studyid] = templates;
         this.allTemplates = templates;

          this.formTemplates = templates;

          if (templates.length > 0) {
            this.formData.form = templates[0].templateId;
          }
        }
        catch (err) {
          console.log(err);
        }
      },

      updateTargetVersionForSites(selectedTemplate) {
  if (!selectedTemplate) return;
  const allVersions = this.allTemplates.filter(
    t => t.templateName === selectedTemplate.templateName
  );

  let latestTemplate = selectedTemplate;
  if (allVersions.length > 0) {
    latestTemplate = allVersions.reduce((latest, current) => {
      const latestVersion = parseFloat(latest.version) || 0;
      const currentVersion = parseFloat(current.version) || 0;
      return currentVersion > latestVersion ? current : latest;
    }, allVersions[0]);
  }

  const targetVersion = latestTemplate.version || "";

  console.log("Latest target version for template:", targetVersion);

  if (this.sites.length > 0) {
    this.sites = this.sites.map(site => ({
      ...site,
      targetVersion: targetVersion
    }));
  }
},
async loadSitesForTemplate(templateName, studyId) {
    try {
        const encodedTemplateName = encodeURIComponent(templateName);
        const response = await axios.get(
            `${this.baseurl}/forms/template/listsitecrfversions?studyId=${studyId}&templateName=${encodedTemplateName}`,
            {
                headers: {
                    Authorization: "Bearer " + this.idtoken,
                    "Content-Type": "application/json",
                },
            }
        );

        const filteredData = response.data.results || [];
        const today = new Date().toISOString().split('T')[0];
        const templateVersion = this.getTemplateVersion(templateName);
        
        this.sites = filteredData.map(item => {
            const currentVersion = item.version || templateVersion || "";
            
            return {
                id: item.siteId,
                siteId: item.siteId,
                sitecode: item.siteCode,
                sitename: item.siteName,
                version: currentVersion,
                effectiveDate: item.effectiveDate ? item.effectiveDate.slice(0, 10) : today,
                transitionRule: "Apply to All Subjects",
                templateName: item.templateName,
                ecrfSourceID: item.ecrfSourceID,
            };
        });
        
        this.currentPage = 1;
        if (this.formData.form) {
            const selectedTemplate = this.templatelistobj[this.studyid]?.find(
                t => t.templateId === this.formData.form
            );
            
            if (selectedTemplate) {
                this.updateTargetVersionForSites(selectedTemplate);
            }
        }
        
        console.log("Sites loaded for template:", templateName, this.sites);
    } catch (err) {
        console.error("Error loading sites for template:", err);
        this.sites = [];
    }
},
getTemplateVersion(templateName) {
    if (!this.templatelistobj[this.studyid]) {
        return null;
    }
    
    const template = this.templatelistobj[this.studyid].find(
        t => t.templateName === templateName
    );
    
    return template ? template.version : null;
},
async getversionhistory(sourceTemplateId) {
    if (!sourceTemplateId) {
        console.warn("No sourceTemplateId");
        return;
    }

    try {
        const response = await axios.get(
            `${this.baseurl}/forms/template/getversionhistory?sourceId=${sourceTemplateId}`,
            {
                headers: {
                    Authorization: "Bearer " + this.idtoken,
                    "Content-Type": "application/json",
                },
            }
        );

        this.versionhistoryarray = response.data || [];
        console.log("Version history:", this.versionhistoryarray);


        
        
        
    } catch (error) {
        console.error("Version history error:", error);
    }
},

toggleSelectAll() {
  const today = new Date().toISOString().split('T')[0];

  if (this.selectAll) {
    this.selectedSites = this.paginatedSites
      .filter(site => !this.isSaveDisabled(site))
      .map(site => ({
        ...site,
        effectiveDate: site.effectiveDate || today
      }));
  } else {
    this.selectedSites = [];
  }
},
        loadPage(page) {
            this.currentPage = page;
            this.selectedSites = [];
            this.selectAll = false;
        },
async saveSingleSite(site) {
  if (this.isSaveDisabled(site)) return;

  const studyId = store.getters.getStudyIs;

  try {
    if (this.selectedSites.length === 0) {
      alert("Please select at least one site");
      return;
    }

    const selectedTemplate = this.templatelistobj[this.studyid]?.find(
      t => t.templateId === this.formData.form
    );

    if (!selectedTemplate) {
      alert("Selected template not found");
      return;
    }

const allVersionsOfTemplate = this.templatelistobj[this.studyid]?.filter(
  t => t.sourceTemplateId === selectedTemplate.sourceTemplateId
) || [];

const latestTemplate = allVersionsOfTemplate.reduce((latest, current) => {
  return (parseFloat(current.version) || 0) > (parseFloat(latest.version) || 0) 
    ? current 
    : latest;
}, selectedTemplate);

const payload = {
  oldTemplateId: selectedTemplate.sourceTemplateId,  
  templateId: latestTemplate.templateId,          
  studyId: studyId,
  studyVersion: "",
  map: true,
  siteIds: [site.id || site.siteId]  
};

    console.log("Saving single site with payload:", payload);

    let updateVisitsSuccess = false;
    let updateSchedulesSuccess = false;

    if (site.transitionRule === "Apply to All Subjects") {
      const [visitsResult, schedulesResult] = await Promise.allSettled([
        axios.post(`${this.baseurl}/forms/template/updatevisits`, payload, {
          headers: {
            Authorization: "Bearer " + this.idtoken,
            "Content-Type": "application/json",
          },
        }),
        axios.get(
          `${this.baseurl}/forms/template/updateschedules?oldTemplateId=${payload.oldTemplateId}&templateId=${payload.templateId}&studyId=${payload.studyId}&siteIds=${payload.siteIds.join(",")}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        )
      ]);

      if (visitsResult.status === "fulfilled") {
        updateVisitsSuccess = true;
        alert("Update visits completed successfully");
      } else {
        console.error("Error in updatevisits:", visitsResult.reason);
        alert(visitsResult.reason?.response?.data?.message || "No SOA item found for this template");
      }

      if (schedulesResult.status === "fulfilled") {
        updateSchedulesSuccess = true;
        alert("Update schedules completed successfully");
      } else {
        console.error("Error in updateschedules:", schedulesResult.reason);
        alert(schedulesResult.reason?.response?.data?.message || "No schedules found for this template");
      }

    } else if (site.transitionRule === "Apply to New Subjects Only") {
      try {
        await axios.post(`${this.baseurl}/forms/template/updatevisits`, payload, {
          headers: {
            Authorization: "Bearer " + this.idtoken,
            "Content-Type": "application/json",
          },
        });
        updateVisitsSuccess = true;
        alert("Update visits completed successfully");
      } catch (err) {
        console.error("Error saving site (updatevisits):", err);
        alert(err.response?.data?.message || "No SOA item found for this template");
      }

    } else {
      try {
        await axios.get(
          `${this.baseurl}/forms/template/updateschedules?oldTemplateId=${payload.oldTemplateId}&templateId=${payload.templateId}&studyId=${payload.studyId}&siteIds=${payload.siteIds.join(",")}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        updateSchedulesSuccess = true;
        alert("Update schedules completed successfully");
      } catch (err) {
        console.error("Error saving site (updateschedules):", err);
        alert(err.response?.data?.message || "No schedules found for this template");
      }
    }

    const overallSuccess = site.transitionRule === "Apply to All Subjects"
      ? (updateVisitsSuccess && updateSchedulesSuccess)
      : (updateVisitsSuccess || updateSchedulesSuccess);

    if (overallSuccess) {
      if (latestTemplate.sourceTemplateId) {
        await this.getversionhistory(latestTemplate.sourceTemplateId);
      }
      await this.loadSitesForTemplate(latestTemplate.templateName, studyId);
      this.selectedSites = this.selectedSites.filter(
        s => (s.id || s.siteId) !== (site.id || site.siteId)
      );
      if (this.selectedSites.length === 0) {
        this.selectAll = false;
      }
    }

  }catch (err) {
    alert(err.response?.data?.message || "No SOA item found for this template");
  }
},
isSaveDisabled(site) {
  return site.version === site.targetVersion;
}
,
async applyAllSelected() {
  const studyId = store.getters.getStudyIs;
  
  try {
    if (this.selectedSites.length === 0) {
      alert("Please select at least one site");
      return;
    }

    this.showLoading = true;

    const selectedTemplate = this.templatelistobj[this.studyid]?.find(
      t => t.templateId === this.formData.form
    );

    if (!selectedTemplate) {
      alert("Selected template not found");
      this.showLoading = false;
      return;
    }


    const allVersionsOfTemplate = this.templatelistobj[this.studyid]?.filter(
      t => t.sourceTemplateId === selectedTemplate.sourceTemplateId
    ) || [];

    const latestTemplate = allVersionsOfTemplate.reduce((latest, current) => {
      return (parseFloat(current.version) || 0) > (parseFloat(latest.version) || 0)
        ? current
        : latest;
    }, selectedTemplate);

    const siteIds = this.selectedSites.map(site => site.id || site.siteId);

    const payload = {
      oldTemplateId: selectedTemplate.sourceTemplateId,
      templateId: latestTemplate.templateId,
      studyId: studyId,
      studyVersion: "",
      map: true,
      siteIds: siteIds
    };

    console.log("Saving multiple sites with payload:", payload);

    const hasApplyToAll = this.selectedSites.some(site => site.transitionRule === "Apply to All Subjects");
    const hasApplyToNewOnly = this.selectedSites.some(site => site.transitionRule === "Apply to New Subjects Only");
    const hasDefault = this.selectedSites.some(site =>
      site.transitionRule !== "Apply to All Subjects" && site.transitionRule !== "Apply to New Subjects Only"
    );

    let updateVisitsSuccess = false;
    let updateSchedulesSuccess = false;

    const needsVisits = hasApplyToAll || hasApplyToNewOnly;
    const needsSchedules = hasApplyToAll || hasDefault;

    const apiCalls = [];
    if (needsVisits) {
      apiCalls.push(
        axios.post(`${this.baseurl}/forms/template/updatevisits`, payload, {
          headers: {
            Authorization: "Bearer " + this.idtoken,
            "Content-Type": "application/json",
          },
        })
      );
    } else {
      apiCalls.push(Promise.resolve(null));
    }

    if (needsSchedules) {
      apiCalls.push(
        axios.get(
          `${this.baseurl}/forms/template/updateschedules?oldTemplateId=${payload.oldTemplateId}&templateId=${payload.templateId}&studyId=${payload.studyId}&siteIds=${payload.siteIds.join(",")}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        )
      );
    } else {
      apiCalls.push(Promise.resolve(null));
    }

    const [visitsResult, schedulesResult] = await Promise.allSettled(apiCalls);

    if (needsVisits) {
      if (visitsResult.status === "fulfilled" && visitsResult.value !== null) {
        updateVisitsSuccess = true;
        alert("Update visits completed successfully for selected sites");
      } else if (visitsResult.status === "rejected") {
        console.error("Error in updatevisits:", visitsResult.reason);
        alert(visitsResult.reason?.response?.data?.message || "No SOA item found for this template");
      }
    }

    if (needsSchedules) {
      if (schedulesResult.status === "fulfilled" && schedulesResult.value !== null) {
        updateSchedulesSuccess = true;
        alert("Update schedules completed successfully for selected sites");
      } else if (schedulesResult.status === "rejected") {
        console.error("Error in updateschedules:", schedulesResult.reason);
        alert(schedulesResult.reason?.response?.data?.message || "No schedules found for this template");
      }
    }

    let overallSuccess = true;
    if (hasApplyToAll) {
      overallSuccess = updateVisitsSuccess && updateSchedulesSuccess;
    } else {
      if (needsVisits && !updateVisitsSuccess) overallSuccess = false;
      if (needsSchedules && !updateSchedulesSuccess) overallSuccess = false;
    }

    this.showLoading = false;

    if (overallSuccess) {
      if (latestTemplate.sourceTemplateId) {
        await this.getversionhistory(latestTemplate.sourceTemplateId);
      }
      await this.loadSitesForTemplate(latestTemplate.templateName, studyId);
      this.selectedSites = [];
      this.selectAll = false;
    }

  } catch (err) {
    this.showLoading = false;
    console.error("Unexpected error in applyAllSelected:", err);
    alert(err.response?.data?.message || "No SOA item found for this template");
  }
},

clear() { this.selectedSites = [];
     this.selectAll = false; 
    this.sites = this.sites.map(site => ({ ...site, transitionRule: "",  effectiveDate: "" })); 
 
        
    this.currentPage = 1; }

    },
};